export default "__VITE_ASSET__Ba6P7c62__"